import { render, staticRenderFns } from "./Vulnerabilidades.vue?vue&type=template&id=fdb2d804&"
import script from "./Vulnerabilidades.vue?vue&type=script&lang=js&"
export * from "./Vulnerabilidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports